const $ = jQuery;

const dockStartingState = (dockId, el) => {
  $(`#dock_item_${dockId}`).removeClass('og-animated'); // Remove class, since it's a starting state
  if ($('#dock_crane_front').length) {
    el.select('#dock_crane_front').opacity(0);
    el.select('#dock_crane_front').transform({ x: -25 });
    el.select('#dock_crane_back').opacity(0);
    el.select('#dock_crane_back').transform({ x: 15 });
  }
  if ($(`#dock_item_${dockId}`).hasClass('dock_lift')) {
    el.select('#ship_lift_leg_1').opacity(0);
    el.select('#ship_lift_leg_2').opacity(0);
    el.select('#ship_lift_leg_3').opacity(0);
    el.select('#ship_lift_leg_4').opacity(0);
    el.select('#dock_lift_2').opacity(0);
    el.select('#dock_lift_2').transform({ y: 10 });
  }
  if ($(`#dock_item_${dockId}`).hasClass('dock_ship_clone')) {
    el.select('#dock_ship_clone').opacity(0);
  }
  el.select(`#dock_item_${dockId}`).transform({ scaleX: 0.01, cx: 0, cy: 0 }); // Scale down dock
  el.select(`#dock_ship_${dockId}`).opacity(0); // Set starting opacity at 0 and fade in after dock scales in
  el.select(`#dock_wave_${dockId}`).opacity(0); // Set starting opacity at 0 and fade in after dock scales in
  el.select(`#dock_ship_${dockId}`).transform({ x: -50 }); // Move ships to the left of starting point
  el.select(`#dock_wave_${dockId}`).transform({ x: -50 }); // Move waves to the left of starting point
};

export default dockStartingState;
